import { createContext, useContext } from 'react';
import { LiveInsightMessage } from '../types/live-insights';

export type ConnectionState = 'idle' | 'connecting' | 'connected' | 'disconnected' | 'error';

export interface LiveInsightsContextType {
    connectionState: ConnectionState;
    setConnectionState: (state: ConnectionState) => void;
    messages: LiveInsightMessage[];
    sendMessage: (transcript: string, speakerId: string) => void;
    addMessage: (message: LiveInsightMessage) => void;
}

export const LiveInsightsContext = createContext<LiveInsightsContextType | undefined>(undefined);

export function useLiveInsightsContext() {
    const context = useContext(LiveInsightsContext);
    if (context === undefined) {
        throw new Error('useLiveInsightsContext must be used within a LiveInsightsProvider');
    }
    return context;
}

/** Convenience helper — components that only need a boolean can use this. */
export function isConnectedState(state: ConnectionState): boolean {
    return state === 'connected';
}
